import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { getLocalStorageItem } from "../utils";

const PublicAuths = () => {
  const isAuthenticated = () => {
    const user = getLocalStorageItem("token") ? true : false;
    return user;
  };
  return isAuthenticated() ? <Navigate to="/dashboard" /> : (
    <ErrorBoundary>
      <Outlet />
   </ErrorBoundary>
);;
};

export default PublicAuths;
